import getHelpList from '@/api/list';

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    // 获取帮助列表
    async getHelpList(context, params) {
      const { data } = await getHelpList(params);
      return data || [];
    },
  },
};
